import { render } from "./PR16-11022022.vue?vue&type=template&id=667e21f6"
import script from "./PR16-11022022.vue?vue&type=script&lang=js"
export * from "./PR16-11022022.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__